module.exports = __webpack_public_path__ + "img/gb879-86-3x22.prt.ad0103c7.jpg";